/**
 * @generated SignedSource<<8767d10d4f8fbcd703f5a6a944c25174>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UnlockProjectSurveyResultsInput = {
  surveyId?: string | null | undefined;
  surveyIds?: ReadonlyArray<string> | null | undefined;
};
export type ApproveDownloadDialog_UnlockProjectSurveyResultsMutation$variables = {
  input: UnlockProjectSurveyResultsInput;
};
export type ApproveDownloadDialog_UnlockProjectSurveyResultsMutation$data = {
  readonly unlockProjectSurveyResults: {
    readonly survey: {
      readonly resultsUnlocked: boolean;
    } | null | undefined;
  };
};
export type ApproveDownloadDialog_UnlockProjectSurveyResultsMutation = {
  response: ApproveDownloadDialog_UnlockProjectSurveyResultsMutation$data;
  variables: ApproveDownloadDialog_UnlockProjectSurveyResultsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resultsUnlocked",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ApproveDownloadDialog_UnlockProjectSurveyResultsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnlockProjectSurveyResultsPayload",
        "kind": "LinkedField",
        "name": "unlockProjectSurveyResults",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectSurvey",
            "kind": "LinkedField",
            "name": "survey",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ApproveDownloadDialog_UnlockProjectSurveyResultsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnlockProjectSurveyResultsPayload",
        "kind": "LinkedField",
        "name": "unlockProjectSurveyResults",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectSurvey",
            "kind": "LinkedField",
            "name": "survey",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5bba1e057784c082b9f2098c42c4760a",
    "id": null,
    "metadata": {},
    "name": "ApproveDownloadDialog_UnlockProjectSurveyResultsMutation",
    "operationKind": "mutation",
    "text": "mutation ApproveDownloadDialog_UnlockProjectSurveyResultsMutation(\n  $input: UnlockProjectSurveyResultsInput!\n) {\n  unlockProjectSurveyResults(input: $input) {\n    survey {\n      resultsUnlocked\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0be73e7e451262f24fba8a15a7e6c3ef";

export default node;
